import { render, staticRenderFns } from "./day-past-due.vue?vue&type=template&id=cb623fd4&"
import script from "./day-past-due.vue?vue&type=script&lang=js&"
export * from "./day-past-due.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports